import { useSnapshot } from 'valtio'
import { uiState } from '../data'
import { AnimatePresence, motion, useAnimation } from 'framer-motion'
import { isMobile } from 'react-device-detect'
import { useEffect, useRef } from 'react'
import { windowSizeState } from '../utils/windowSize'

const DetailPage = ({ event }) => {
  const { visible } = useSnapshot(uiState[event])
  const { mobileMode } = useSnapshot(windowSizeState)
  const contentRefPc = useRef()
  const contentRefPh = useRef()

  useEffect(() => {
    if (visible) {
      uiState.iconState = 135
      if (contentRefPc.current) {
        contentRefPc.current.scrollTop = '0%'
      }
      if (contentRefPh.current) {
        contentRefPh.current.scrollTop = '20%'
      }
    } else {
      uiState.iconState = 0
    }
  }, [visible, mobileMode])

  return (
    <>
      {/* 行動版 */}
      <AnimatePresence>
        <motion.div
          className={`fixed top-0 left-0 screen-setting z-[60] overflow-y-scroll ${
            visible && mobileMode
              ? 'pointer-events-auto'
              : 'pointer-events-none'
          }`}
          onClick={(e) => {
            e.stopPropagation()
          }}
          ref={contentRefPh}
        >
          <motion.div
            className='w-full h-full fixed top-0 left-0 bg-mainOrange-100'
            initial={{ opacity: 0 }}
            animate={{ opacity: visible && mobileMode ? 1 : 0 }}
            transition={{ duration: 1 }}
          ></motion.div>
          <motion.div
            className='absolute top-[20%] left-0  w-full  rounded-t-[20px]   flex  '
            initial={{ top: '300%' }}
            animate={{ top: visible && mobileMode ? '20%' : '300%' }}
            transition={{ duration: 1 }}
          >
            <div className=' absolute top-0 right-0 h-[50px] w-full bg-mainOrange-100 border-x-[3px] border-t-[3px] border-white  rounded-t-[20px]'></div>
            <div className=' absolute  w-full left-0 top-[50px] bg-bgColor-100  '>
              <div className='w-[100%] flex flex-col items-center justify-center border-x-[3px] border-b-[3px] border-white py-[3%] '>
                <img
                  src='../startImages/thx_4_v1.png'
                  alt='人員名單'
                  className='w-[60%] object-contain  my-4 portraitBigPh:w-[85%] '
                />
              </div>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      {/* 電腦版 */}
      <AnimatePresence>
        <motion.div
          className={`fixed top-0 left-0 screen-setting z-[60]  ${
            visible && !mobileMode
              ? ' pointer-events-auto'
              : ' pointer-events-none'
          }`}
        >
          <motion.div
            className=' absolute top-0 left-0 w-full h-full bg-mainOrange-100'
            initial={{ opacity: 0 }}
            animate={{ opacity: visible && !mobileMode ? 1 : 0 }}
            transition={{ duration: 1 }}
          ></motion.div>
          <motion.div
            className='absolute top-0 left-0 w-[40%] h-full  bg-bgColor-100 rounded-r-[20px] border-[3px] border-white landscapePad:w-[55%] overflow-y-scroll '
            initial={{ top: '200%' }}
            animate={{ top: visible && !mobileMode ? '0%' : '200%' }}
            transition={{ duration: 1 }}
            ref={contentRefPc}
          >
            <div className='w-[100%] flex flex-col  justify-center   py-[70px] absolute top-0 left-0 pl-[50px] '>
              <div className=' absolute top-0 right-0 w-[50px] h-full bg-mainOrange-100 rounded-r-[20px] border-l-[3px] border-white'></div>
              <img
                src='../startImages/thx_4_v1.png'
                alt='人員名單'
                className='w-[65%] landscapePad:w-[70%] object-contain  my-4 portraitBigPh:w-[85%] '
              />
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>
    </>
  )
}

export default DetailPage
